import { render, staticRenderFns } from "./garden28.vue?vue&type=template&id=ad29039e&scoped=true&"
import script from "./garden28.vue?vue&type=script&lang=js&"
export * from "./garden28.vue?vue&type=script&lang=js&"
import style0 from "./garden28.vue?vue&type=style&index=0&id=ad29039e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad29039e",
  null
  
)

export default component.exports